<template>
     <vs-dialog prevent-close @close="limpiarInfo" v-model="active" width="800px">
        <template #header>
          <h4 class="not-margin">
              Crear una asignatura
          </h4>
        </template>
        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">Clave</label>
                    <vs-input class="pt-0" v-model="clave" placeholder="Clave">
                        <template #message-danger v-if="errorFields.includes('clave')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">Nombre</label>
                    <vs-input class="pt-0" v-model="nombre" placeholder="Nombre">
                        <template #message-danger v-if="errorFields.includes('nombre')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">Créditos</label>
                    <vs-input class="pt-0" v-model="creditos" placeholder="Créditos">
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">N° Horas Prácticas</label>
                    <vs-input class="pt-0" v-model="num_horas_practicas" placeholder="N° Horas Prácticas">
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">N° Horas Teoricas</label>
                    <vs-input class="pt-0" v-model="num_horas_teoricas" placeholder="N° Horas Teoricas">
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">Asignaturas previas obligatorias</label>
                    <vs-select
                        filter
                        class="pt-0"
                        placeholder="Asignaturas previas obligatorias"
                        v-model="asignaturas_obligatorias_previas_ids"
                        :key="asignaturaId"
                    >
                        <template #message-danger v-if="errorFields.includes('asignaturas_obligatorias_previas_ids')">
                            Requerido
                        </template>
                        <vs-option-group v-for="(asig, i) in asignaturas" :key="i">
                            <div slot="title">
                                {{asig.nombre}}
                            </div>
                            <vs-option v-for="(opcion, j) in asig.asignaturas" :key="j" :label="opcion.nombre" :value="opcion.id">
                                {{opcion.nombre}}
                            </vs-option>
                        </vs-option-group>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="mb-0" style="padding-left: 10px;">Mínimo de créditos para cursar asignatura</label>
                    <vs-input class="pt-0" v-model="minimo_creditos_necesarios" placeholder="Mínimo de créditos para cursar asignatura">
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <div class="form-group neutron mb-3">
                    <label class="mb-0" style="padding-left: 10px;">Estilo</label>
                    <vs-select class="pt-0" placeholder="Select" v-model="color">
                        <vs-option :style="'background:' + color.color + '; color:' + color.letra" v-for="(color,i) in colores" :label="color.label" :key="i" :value="color.nombre">
                            {{color.label}}
                        </vs-option>
                    </vs-select>
                    </div>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="limpiarInfo(), active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="postCrearAsignatura()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'row',
      'plan',
      'areaId'
    ],
    data () {
        return {
            active: false,
            asignaturas: [],
            asignaturaId:  (new Date()).getTime(),
            clave: '',
            nombre: '',
            creditos: '',
            num_horas_practicas: '',
            num_horas_teoricas: '',
            minimo_creditos_necesarios: '',
            asignaturas_obligatorias_previas_ids: '',
            estilo: '',
            errorFields: [],
            color: '',
            colores: [
                {
                    label: 'NEUTRAL',
                    nombre: 'neutro',
                    color: '#E6E6E6',
                    letra: '#868686'
                },
                {
                    label: 'ORO',
                    nombre: 'oro',
                    color: '#d4a017',
                    letra: 'white'
                },
                {
                    label: 'LILA',
                    nombre: 'lila',
                    color: '#9f67aa',
                    letra: 'white'
                },
                {
                    label: 'CIAN',
                    nombre: 'cian',
                    color: '#00b4cb',
                    letra: 'white'
                },
                {
                    label: 'MELÓN',
                    nombre: 'melon',
                    color: '#fbccb0',
                    letra: 'white'
                },
                {
                    label: 'OCRE',
                    nombre: 'ocre',
                    color: '#e77625',
                    letra: 'white'
                },
                {
                    label: 'AZUL',
                    nombre: 'azul',
                    color: '#1e55a5',
                    letra: 'white'
                },
                {
                    label: 'PURPURA',
                    nombre: 'purpura',
                    color: '#6b4d9f',
                    letra: 'white'
                },
                {
                    label: 'VERDE MENTA',
                    nombre: 'verde-menta',
                    color: '#67bf81',
                    letra: 'white'
                },
                {
                    label: 'TURQUESA',
                    nombre: 'turquesa',
                    color: '#00b3b3',
                    letra: 'white'
                },
                {
                    label: 'SALMÓN',
                    nombre: 'salmon',
                    color: '#f17871',
                    letra: 'white'
                },
                {
                    label: 'BEIGE',
                    nombre: 'beige',
                    color: '#eef3d4',
                    letra: '#868686'
                },
                {
                    label: 'MOSTAZA',
                    nombre: 'mostaza',
                    color: '#fdd35e',
                    letra: 'white'
                },
                {
                    label: 'ROSA',
                    nombre: 'rosa',
                    color: '#f06aa7',
                    letra: 'white'
                }
            ]
        }
    },
    methods: {
        async getAsignaturas(){
            try{
                const response = await academico.getAsignaturas(this.plan)
                this.asignaturas = response.data
                this.asignaturaId = (new Date()).getTime()
            } catch (error) {
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.clave) {
                this.errorFields.push('clave')
            }
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.asignaturas_obligatorias_previas_ids) {
                this.errorFields.push('asignaturas_obligatorias_previas_ids')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postCrearAsignatura(){
            if(this.sanityForm){
                const loading = this.$vs.loading()
                try{
                    const params = {
                        area_id: this.areaId,
                        clave: this.clave,
                        creditos: this.creditos,
                        estilo: this.color,
                        minimo_creditos_necesarios: this.minimo_creditos_necesarios,
                        nombre: this.nombre,
                        num_horas_practicas: this.num_horas_practicas,
                        num_horas_teoricas: this.num_horas_teoricas,
                        asignaturas_obligatorias_previas_ids: this.asignaturas_obligatorias_previas_ids
                    }
                    const response = await academico.postCrearAsignatura(params)
                    loading.close()
                    this.active = false
                    this.limpiarInfo()
                    this.$emit('refreshTable')
                    this.$vs.notification({
                        sticky: true,
                        color: 'success',
                        position: null,
                        title: 'Se a creado con éxito la asignatura'
                    })
                } catch (error) {
                    loading.close()
                    console.log(error)
                    this.$vs.notification({
                    color: 'danger',
                    position: null,
                    title: 'Algo salio mal, favor de contactar al administrador '
                    })
                }
            } 
        },
        limpiarInfo(){
            this.areaId = ''
            this.clave = ''
            this.creditos = ''
            this.color = ''
            this.minimo_creditos_necesarios = ''
            this.nombre = ''
            this.num_horas_practicas = ''
            this.num_horas_teoricas = ''
            this.asignaturas_obligatorias_previas_ids = ''
        }
     },
    watch: {
        value (val) {
            this.active = val
            this.getAsignaturas()
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>
<style scoped>
label{
    font-size: 0.75rem;
}
</style>